import { render } from "./GrupoListDialog.vue?vue&type=template&id=130c8c6a"
import script from "./GrupoListDialog.vue?vue&type=script&lang=js"
export * from "./GrupoListDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__